import { CalendarInput, Modal, Radio, TextInput, Typography } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';

import { EndRepeatModalContainer } from '../styles/event';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const EndRepeatModal = ({
  onCancel,
  value,
  onChangeChecked,
  onChangeDate,
  onChangeOccurrences,
  onSubmit,
  calendarKey,
}: {
  onCancel: () => void;
  value: any;
  onChangeChecked: (value: any) => void;
  onChangeDate: (date: Date) => void;
  onChangeOccurrences: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  calendarKey: {
    value: number;
    setValue: (value: number) => void;
  };
}) => {
  const safeDate =
    value.date instanceof Date && !isNaN(value.date.getTime()) ? value.date : new Date();

  return (
    <EndRepeatModalContainer>
      <Modal
        header={
          <Typography variant="h4" style={{ fontSize: 22, fontWeight: '500' }}>
            End Repeat
          </Typography>
        }
        closeIconStyle={{
          width: 24,
          height: 24,
        }}
        modalKey={MODAL_KEY.END_REPEAT}
        onCancel={onCancel}
        style={{ background: COLOR_CONFIG.white }}
        onSubmit={onSubmit}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 16,
          }}
        >
          <Radio
            checked={value.on}
            onClick={() => onChangeChecked('on')}
            style={{
              marginRight: 10,
            }}
          >
            On
          </Radio>
          <CalendarInput
            key={calendarKey?.value}
            containerStyle={{ pointerEvents: !value.on ? 'none' : 'auto' }}
            date={safeDate}
            onChange={onChangeDate}
            disabled={!value.on}
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Radio
            checked={value.after}
            onClick={() => onChangeChecked('after')}
            style={{
              marginRight: 10,
            }}
          >
            After
          </Radio>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <TextInput
              containerStyle={{ width: 70, height: 32 }}
              value={value.occurrences}
              onChange={onChangeOccurrences}
              disabled={!value.after}
            />
            <Typography
              variant="body-2"
              color={
                value.after ? COLOR.surfaceNeutralBold['neutral-11'] : COLOR_CONFIG['neutral-text']
              }
            >
              occurrences
            </Typography>
          </div>
        </div>
      </Modal>
    </EndRepeatModalContainer>
  );
};
